import React from "react";
import "./HeveaGrip.css";
import HeveaGripLogo from "../../../assets/heveagriplogowhite.png";

function HeveaGrip() {
  return (
    <div className="heveagrip-containers">
      <div className="heveagrip-content">
        <a href="https://heveagrip.com" target="_blank" rel="noopener noreferrer">
          <div className="heveagrip-logo-container">
            <img
              src={HeveaGripLogo}
              alt="HeveaGrip Logo"
              className="heveagrip-logo"
            />
          </div>
        </a>

        <div className="heveagrip-text-container">
          <h1 className="heveagrip-main-title">HeveaGrip.com</h1>
          <h2 className="heveagrip-second-title">
          Revolutionizing Vehicle Services with Electric Mobility Solutions
          </h2>
          <p className="heveagrip-descriptions">
            Enter the realm of HeveaGrip.com, your ultimate destination for
            comprehensive vehicle services and cutting-edge electric mobility
            solutions. Our team of seasoned professionals boasts unmatched
            expertise in repairs, maintenance, and seamless spare parts
            replacement, catering to a diverse range of vehicles from electric
            cars to traditional motorbikes. Committed to excellence, we
            prioritize the care of your valuable vehicles, exclusively endorsing
            original brand services and utilizing authentic spare parts for
            every task.
            <br></br>
            <br></br>
            Empowering the Future with Innovative Electric Mobility Solutions
            <br />
            <br />• Premium all-season tires of unparalleled quality catering to
            diverse vehicle types.
            <br></br>• Vehicle Repair and Maintenance: Comprehensive services
            for cars, motorcycles, and diverse electric vehicles, encompassing
            repairs, maintenance, and precise spare parts replacement.
            <br></br>• DC Fast Charging: Facilitating swift, high-capacity
            charging.
            <br></br>• Vehicle-to-Grid Charging: Enabling a two-way exchange of
            energy.
          </p>
         
        </div>
      </div>
    </div>
  );
}

export default HeveaGrip;
